import React, { useState, useCallback } from "react";
import { Tabs, Tab, Box, Tooltip, Typography, Stack } from "@mui/material";
import AlarmsHistory from "../alarmsHistory/AlarmsHistory";
import { useTranslation } from "react-i18next";
import { useServiceMode } from "../../../../hooks/useReduxSelectors";
import EditRangesTable from "../editAlarms/EditRangesTable";
import CreateDeleteAlarms from "../editAlarms/CreateDeleteAlarms";

const AlarmsTabs = () => {
  const [topTab, setTopTab] = useState("alarms");
  const [alarmsSubTab, setAlarmsSubTab] = useState("all");
  const [configSubTab, setConfigSubTab] = useState("editRanges");
  const { t } = useTranslation();
  const serviceModeActive = useServiceMode()?.isActive;

  const handleTopTab = (event, newValue) => setTopTab(newValue);
  const handleAlarmsSubTab = (event, newValue) => setAlarmsSubTab(newValue);
  const handleConfigSubTab = (event, newValue) => setConfigSubTab(newValue);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", flex: "1 1 0", minHeight: 0, minWidth: 0 }}>
      <Tabs
        value={topTab}
        onChange={handleTopTab}
        variant="fullWidth"
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Tab value="alarms" label={t("Alarms")} />
        <Tab value="configuration" label={t("Alarm Configuration")} />
      </Tabs>

      {topTab === "alarms" && (
        <Tabs
          value={alarmsSubTab}
          onChange={handleAlarmsSubTab}
          variant="fullWidth"
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          <Tab value="all" label={t("All")} />
          <Tab value="device" label={t("Devices")} />
          <Tab value="sample" label={t("Samples")} />
        </Tabs>
      )}

      {topTab === "configuration" && (
        <Tabs
          value={configSubTab}
          onChange={handleConfigSubTab}
          variant="fullWidth"
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          <Tab value="editRanges" label={t("Ranges")} />
          <Tab value="createDelete"
            label={t("Create / Delete Custom Alarms")}
            disabled={!serviceModeActive}
          />
        </Tabs>
      )}

      {topTab === "alarms" && <AlarmsHistory alarmsPageId={alarmsSubTab} />}
      {topTab === "configuration" && configSubTab === "editRanges" && <EditRangesTable />}
      {topTab === "configuration" && configSubTab === "createDelete" && <CreateDeleteAlarms />}
    </Box>
  );
};

export default AlarmsTabs;
